














































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { Section } from '@/domain/Section'

@Component
export default class SectionDialogComponent extends Vue {
  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: Section, default: () => new Section(), required: true })
  dto!: Section

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  /**
   * 初期化
   */
  reset() {
    this.dto = new Section()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
